import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import IndividualDirectcostbudgetContainer from '../../containers/individual-directcost-budget/IndividualDirectcostbudgetContainer';

const IndividualDirectcostbudgetPage = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="판관비 관리/개인별 직접비 예산"
        icon="budget"
      />
      <IndividualDirectcostbudgetContainer />
    </>
  );
};

export default IndividualDirectcostbudgetPage;
